// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"442":"4122c3ec","713":"d2c16f91"}[chunkId] + ".chunk.js";
};